import { useNavigate } from 'react-router';
import classNames from 'classnames';

import { RouteTo } from '../../routes';

import { Carousel } from '../../types/carouselTypes';

import styles from './CarouselsTable.module.scss';

type FeaturedCarouselsTableProps = {
    carousels: Carousel[];
    onActivateCarouselClick: (carousel: Carousel) => Promise<void>;
    onCopyCarouselClick: (carouselName: Carousel['carouselName']) => void;
    onCarouselDeleteClick: (i: number) => Promise<void>;
};

export const FeaturedCarouselsTable = (props: FeaturedCarouselsTableProps) => {
    const { carousels } = props;
    const navigate = useNavigate();

    return (
        <table className={styles.featuredCarouselsTable}>
            <tbody>
                {carousels.map((c: Carousel, i: number) => {
                    return (
                        <tr
                            key={c.carouselName}
                            className="draggableCarousel"
                            onClick={() =>
                                navigate(
                                    RouteTo.CarouselEdit(String(c.carouselId)),
                                )
                            }
                        >
                            <td>{c.carouselName}</td>

                            <td className={styles.buttons}>
                                <button
                                    className={classNames(
                                        'small',
                                        !c.active ? 'positive' : 'warning',
                                    )}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        props.onActivateCarouselClick(c);
                                    }}
                                >
                                    {!c.active ? 'Activate' : 'Deactivate'}
                                </button>
                                <button
                                    className="small primary"
                                    onClick={() =>
                                        navigate(
                                            RouteTo.CarouselEdit(
                                                String(c.carouselId),
                                            ),
                                        )
                                    }
                                >
                                    Edit carousel
                                </button>
                                <button
                                    className="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        props.onCopyCarouselClick(
                                            c.carouselName,
                                        );
                                    }}
                                >
                                    Copy to...
                                </button>
                                <button
                                    className="small danger"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        props.onCarouselDeleteClick(i);
                                    }}
                                >
                                    Delete
                                </button>
                            </td>

                            <td className={styles.dragHandlePlaceholder} />
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
